export const DONATE = {
  packageCard: (id) => `donate-package-card-${id}`,
  packageSelectButton: (id) => `donate-package-select-button-${id}`,
  customAmountInput: 'donate-custom-amount-input',
  frequencyOneTime: 'donate-frequency-one-time',
  frequencyMonthly: 'donate-frequency-monthly',
  nameInput: 'donate-name-input',
  emailInput: 'donate-email-input',
  donateButton: 'donate-submit-button',
  successMessage: 'donate-success-message',
  statusPending: 'donate-status-pending',
};

export const MERCH = {
  shopButton: 'merch-shop-external-button',
};
